import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomInput from '../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb';
import './inserir-midia-digital.scss'
import 'bootstrap/dist/css/bootstrap.min.css';
import { AudioVideoImageDropzone } from '../../../../components/common/audioVideoImageDropzone/audio-video-image-dropzone';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Select,
} from '@chakra-ui/react';
import { FileWithPath } from 'react-dropzone';
import * as api from '../../../../api/midiaDigital';
import Swal from 'sweetalert2';
import CustomTextArea from '../../../../components/common/Textarea/textArea';

interface MidiaParams {
  dscMidia: string;
  seqUsuario: any;
  dscUriCdn: string | null;
  codMidia: number | null;
  dscDescricao: string | null;
  dscDireitoAutoral: string | null;
}

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

const InserirMidiaDigital: React.FC = () => {
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState<{
    titulo: { value: string; error: boolean };
    arquivoMidia: { value: string; error: boolean };
    dscDireitoAutoral: { value: string; error: boolean };
    tipoMidiaId: { value: string; error: boolean };
    dscDescricao: { value: string; error: boolean };
  }>({
    titulo: { value: '', error: false },
    arquivoMidia: { value: '', error: false },
    dscDireitoAutoral: { value: '', error: false },
    tipoMidiaId: { value: '', error: false },
    dscDescricao: { value: '', error: false },
  });

  const [arquivo, setArquivo] = useState<any>();
  const [nomeArquivo, setNomeArquivo] = useState<any>();
  const [seqUsuario, setSeqUsuario] = useState<any[]>([]);
  const [tipoMidia, setTipoMidia] = useState<any[]>([]);
  const [typeMidia, setTypeMidia] = useState<any>();
  const [arquivoSelecionado, setArquivoSelecionado] = useState<File | null>(null);
  const [isLoadingButton, setLoadingButton] = useState<boolean>(false);

  useEffect(() => {
    const storedUsuario = localStorage.getItem('dadosUsuario');
    if (storedUsuario) {
      try {
        const usuario = JSON.parse(storedUsuario);
        setSeqUsuario(usuario.seqUsuario);

      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }

    const fetchtipoMidia = async () => {
      try {
        const data = await api.listarTipoDeMidia();
        setTipoMidia(data);
      } catch (error) {
        console.error('Erro ao buscar tipos de mídia:', error);
      }
    };

    fetchtipoMidia();
  }, []);

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  const handleMidiaSelecionada = async (selected: FileWithPath | null) => {
    if (selected) {
      const isImage = selected.type.startsWith("image/");
      const isVideo = selected.type.startsWith("video/");
      const isAudio = selected.type.startsWith("audio/");
      const isPdf = selected.type === "application/pdf" || selected.name.toLowerCase().endsWith('.pdf');

      setNomeArquivo(selected.name);
      setTypeMidia(selected.type);
      setArquivo(selected);

      if (isImage || isVideo || isAudio || isPdf) {
        setArquivoSelecionado(selected);
        setArquivo(selected);

      } else {
        console.error("Tipo de arquivo não suportado.");
      }
    } else {
      setArquivo(null);
      setArquivoSelecionado(null);
      console.warn("Nenhum arquivo selecionado.");
    }
  };

  const isFormValid = () => {
    const { titulo, tipoMidiaId, dscDescricao, dscDireitoAutoral } = formValues;
    const isFileSelected = arquivoSelecionado !== null;

    const isValid = (
      titulo.value &&
      tipoMidiaId.value &&
      dscDescricao.value &&
      isFileSelected
    );

    // console.log("isFormValid:", {
    //   titulo: titulo.value,
    //   tipoMidiaId: tipoMidiaId.value,
    //   isFileSelected,
    //   dscDescricao: dscDescricao,
    //   dscDireitoAutoral: dscDireitoAutoral
    // });

    return isValid;
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoadingButton(true);

    const { tipoMidiaId } = formValues;

    const params: MidiaParams = {
      dscMidia: formValues.titulo.value,
      seqUsuario: seqUsuario,
      dscUriCdn: null,
      codMidia: Number(tipoMidiaId.value) || null,
      dscDescricao: formValues.dscDescricao.value || null,
      dscDireitoAutoral: formValues.dscDireitoAutoral.value || null
    };

    if (arquivoSelecionado) {
      try {
        const formData = new FormData();
        formData.append("file", arquivo);

        const fileExtension = arquivoSelecionado.name.split('.').pop();
        let fileNameToSend = 'midiaDigital';

        if (
          fileExtension &&
          !fileNameToSend.toLowerCase().endsWith(`.${fileExtension.toLowerCase()}`)
        ) {
          fileNameToSend = `${fileNameToSend}.${fileExtension}`;
        }

        const nomePasta = 'bibliotecaDigital';

        formData.append("fileName", fileNameToSend);
        formData.append("folderName", nomePasta);

        const cdnData = await api.inserirNoCdn(formData);

        let cdnUrl = "";
        if (typeof cdnData === "string") {
          const regex = /(https?:\/\/[^\s]+)/g;
          const match = cdnData.match(regex);
          if (match && match[0]) {
            cdnUrl = match[0];
          } else {
            throw new Error("URL não encontrada na resposta do CDN.");
          }
        } else if (cdnData && cdnData.url) {
          cdnUrl = cdnData.url;
        } else {
          throw new Error("Resposta do CDN inesperada.");
        }

        params.dscUriCdn = cdnUrl;

        await api.inserirMidiaDigital(params);
        setLoadingButton(false);

        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: "Mídia inserida com sucesso.",
          confirmButtonColor: "#1789FC",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/cms/publicacao/gerenciar-biblioteca");
        });
      } catch (error) {
        setLoadingButton(false);
        console.error("Erro ao fazer upload da mídia:", error);
        Swal.fire({
          icon: "error",
          title: "Erro ao enviar mídia!",
          text: "Houve um problema ao enviar o arquivo. Tente novamente.",
          confirmButtonColor: "#1789FC",
          confirmButtonText: "OK",
        });
      }
    } else {
      console.warn("Nenhum arquivo selecionado");
    }
  };

  return (
    <Flex
      direction="column"
      padding='40px'
      background-color='#fafafa'
      width='100%'
      height='100%'
      overflow='hidden'
    >
      <SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Nova Mídia Digital
      </Heading>
      <Box m="40px 0" w="100%">
        <form onSubmit={handleFormSubmit}>
          <div className="row">
            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.titulo.error}>
                <FormLabel mb="8px">Tipo de Mídia</FormLabel>
                <Select
                  placeholder='Selecione um tipo de mídia'
                  borderColor="gray.300"
                  _hover={{ borderColor: 'blue.500' }}
                  value={formValues.tipoMidiaId.value}
                  onChange={(e) => handleFieldChange('tipoMidiaId', e.target.value)}
                >
                  {tipoMidia.length > 0 ? (
                    tipoMidia.map(midia => (
                      <option key={midia.codMidia} value={midia.codMidia}>
                        {midia.dscMidia}
                      </option>
                    ))
                  ) : (
                    ''
                  )}
                </Select>
              </FormControl>
            </div>

            <div className="col-md-6 mb-4">
              <FormControl isRequired isInvalid={formValues.titulo.error}>
                <FormLabel mb="8px">Nome da Mídia</FormLabel>
                <CustomInput
                  value={formValues.titulo.value}
                  onChange={(e: any) => handleFieldChange('titulo', e.target.value)}
                  placeholder="Digite um nome"
                  maxLength={60}
                />
              </FormControl>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-6 mb-4">
              <FormControl isRequired className='mb-4'>
                <FormLabel mb="8px">Upload do arquivo digital</FormLabel>
                <AudioVideoImageDropzone
                  onImageSelected={handleMidiaSelecionada}
                  base64={arquivo}
                  width={'100%'}
                  height={300}
                />
              </FormControl>
              <FormControl isRequired>
                <FormLabel mb="8px">Descrição da Mídia</FormLabel>
                <CustomTextArea
                  placeholder='Digite uma descrição'
                  value={formValues.dscDescricao.value}
                  onChange={(e) => handleFieldChange('dscDescricao', e.target.value)}
                  maxLength={100}
                />
              </FormControl>
            </div>
            <div className="col-md-6 mb-4">
              <FormControl isInvalid={formValues.dscDireitoAutoral.error}>
                <FormLabel mb="8px">Direito autoral</FormLabel>
                <CustomInput
                  value={formValues.dscDireitoAutoral.value}
                  onChange={(e: any) => handleFieldChange('dscDireitoAutoral', e.target.value)}
                  placeholder="Digite o direito autoral da mídia"
                  maxLength={200}
                />
              </FormControl>
            </div>
          </div>

          <Flex mt="35px" justifyContent="end">
            <Button
              m="6px"
              onClick={() => navigate('/cms/publicacao/gerenciar-biblioteca')}
            >
              Desistir
            </Button>
            <Button
              type="submit"
              m="6px"
              color="#FFF"
              bgColor="#1665D8"
              _hover={{ opacity: 0.8 }}
              isDisabled={!isFormValid()}
              isLoading={isLoadingButton}
              loadingText="Inserindo..."
            >
              Criar Mídia
            </Button>
          </Flex>
        </form>
      </Box>
    </Flex>
  );
};

export default InserirMidiaDigital;
